$(document).ready(function() {
  let $form = $(".productsidebar-choose-order-target-form");
  if ($form.length > 0) {
    let getSelectedOrderTargetId = () => $form.find("input[type=radio]:checked").val();

    let handleSelectedOrderTargetChange = function() {
      // Disable/undisable the submit button if an order target has been chosen
      $form.find("[type=submit]").toggleClass("disabled", !getSelectedOrderTargetId());
    };

    $form.find("input[type=radio]").change(handleSelectedOrderTargetChange);
    handleSelectedOrderTargetChange();

    // If the order target hasn't been chosen,
    // disable the form submit, and instead scroll the view to the order targets list
    let handleFormSubmit = function() {
      if (!getSelectedOrderTargetId()) {
        st.ScrollToAnchor.scrollTo("#wybierz-opcje");
        return false;
      }
    };
    return $form.submit(handleFormSubmit);
  }
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/productsidebar-choose-order-target-form.js